<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";
import { useClaimStore, useNotificationStore } from '@/store';
import { CogIcon, ArrowTopRightOnSquareIcon, EnvelopeIcon, ScaleIcon } from '@heroicons/vue/24/solid';

import adminAPI from '../../services/api';
import { isValidEmail } from "@/utils";
import openBoxFolderForCurrentClaim, { openBoxSharedFolderForCurrentClaim } from "../../utils/open-box-folder";
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import { storeToRefs } from 'pinia';
import { computedAsync } from '@vueuse/core';
import BoxFilePicker from '../Box/BoxFilePicker.vue';
import { FileSignatureIcon } from 'lucide-vue-next';
import BaseInput from '../ui/inputs/BaseInput.vue';
import BaseButton from '../ui/buttons/BaseButton.vue';
import { BadgeCheckIcon } from 'lucide-vue-next';
import LoaderButton from '../ui/loaders/LoaderButton.vue';
import { InfoIcon } from 'lucide-vue-next';

const numeroRG = ref("");
const isSubmitting = ref(false);

async function setProcedureIdentifier() {
  if (!numeroRG) {
    useNotificationStore().emitNotification({ title: "Aucun tribunal sélectionné" });
    return;
  };
  try {
    isSubmitting.value = true;
    await adminAPI.setProcedureIdentifier(useClaimStore().claim.id, { numeroRG: numeroRG.value })
    await useClaimStore().refreshClaim()
    useNotificationStore().emitNotification({ title: "Procédure connectée", message: "Numéro RG enregistré avec succès" })
  } catch (error) {}
  finally {
    isSubmitting.value = false;
  }
}
</script>
<template>
<div class="border-b bg-slate-50">
  <div class="max-w-lg py-5 mx-auto text-left">
    <div class="p-8 bg-white border rounded-md shadow">
      <h2 class="inline-flex text-base font-semibold leading-6 text-gray-900 align-middle">
        <div class="py-1 mr-2"><DotLegalStep :legal-step-name="useClaimStore().claim.claimLegalStep.name" /></div>
        Actions requises
      </h2>
      <p class="mt-1 text-sm leading-6 text-gray-500">
        Saisir le numéro RG du dossier.<br>
        Pour synchroniser la claim avec le Tribunal Digital et recevoir des alertes.
      </p>

      <div class="relative block text-sm">
        <div class="py-6">
          <BaseInput :icon="ScaleIcon" label="Numéro RG" placeholder="Example « 2023F00210 »" v-model="numeroRG" />
          <div class="mt-3">
          <BaseButton @click="setProcedureIdentifier" text="Sauvegarder" :loading="isSubmitting" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>